import { gql } from 'apollo-boost';

const manyQuery = gql`
  query activities($inputFilter: ActivityFilterInputObjectType) {
    activities(inputFilter: $inputFilter) {
      verb {
        type
        name
      }
      reason
      createdAt
      actor {
        id
        name
      }
      changes {
        name
        previous
        current
      }
    }
  }
`;

const ACTIVITIES = {
  manyQuery,
};

export default ACTIVITIES;
